import { useState } from 'react';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/93b4cb3b7b04e49ebc75ce203b7c68fd.jpg"
          alt="天健商业广场园区实景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 text-center" style={{ paddingTop: '96px' }}>

        {/* 一句话定位 */}
        <h1 className="text-6xl font-bold text-white mb-5 leading-tight tracking-tight">
          建材家居产业带联动中枢
        </h1>

        {/* 副标题 - 限宽，不铺满 */}
        <p className="text-xl text-white/80 mb-10 max-w-[560px] mx-auto leading-relaxed">
          连接批发市场、跨境电商园区与多地制造协同
        </p>

        {/* 三中枢标签 */}
        <div className="flex items-center justify-center gap-4 mb-12">
          {[
            { icon: 'ri-store-2-line', label: '批发集散' },
            { icon: 'ri-global-line', label: '跨境园区' },
            { icon: 'ri-links-line', label: '产业带联动' },
          ].map((tag) => (
            <div
              key={tag.label}
              className="flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm border border-[#C9A84C]/40 rounded-full text-white font-medium text-base hover:bg-[#C9A84C]/20 hover:border-[#C9A84C]/70 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className={`${tag.icon} text-[#C9A84C]`}></i>
              {tag.label}
            </div>
          ))}
        </div>

      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 text-white/50 animate-bounce">
          <span className="text-xs tracking-widest">向下滚动</span>
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}
